/* 큐레이션된 색상/아이콘 선택지 — 카테고리·큰 주제 편집 UI 공용. */

export const PALETTE = [
  '#0d9aa6', '#2e6fff', '#1f9d6b', '#6b56ff', '#d6488a',
  '#e07b1a', '#8457e6', '#e11d48', '#0ea5e9', '#65a30d',
];

// hex → 아주 옅은 배경 틴트 (12% 알파 위에 흰색)
export const tint = (hex) => {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const mix = (c) => Math.round(c + (255 - c) * 0.86);
  return `rgb(${mix(r)},${mix(g)},${mix(b)})`;
};

export const ICON_CHOICES = ['flag', 'chip', 'window', 'code', 'ai', 'robot', 'bulb', 'book', 'doc', 'play', 'community', 'search'];
